<template>
  <v-container py-0>
    <og-table>
      <thead>
        <tr>
          <th class="text-xs-center">
            <b>{{ $t('Subir') }}</b>
          </th>
          <th
            class="text-xs-center pa-0"
            :class="{ 'secondary lighten-4': currentMonth == month }"
            v-for="(month, m) in months"
            :key="m"
          >
            <b>{{ month }}</b>
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-if="formConfigReady">
          <tr>
            <td class="primary--text px-1 text-xs-center">
              <b>{{ $t('Facturas recibidas') }}</b>
            </td>
            <td
              class="px-0 text-xs-center"
              :class="{
                'secondary lighten-4':
                  currentDay >= 1 && currentDay <= 10
                    ? previousMonth == getMonthDate(month)
                    : currentMonth == getMonthDate(month),
              }"
              v-for="(month, m) in monthsN"
              :key="m"
            >
              <v-hover>
                <v-btn
                  slot-scope="{ hover }"
                  flat
                  icon
                  :color="`${hover ? 'primary' : 'grey lighten-1'}`"
                  @click="openUploadForm(month, 'received-invoice')"
                >
                  <v-icon>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-hover>
            </td>
          </tr>
          <tr>
            <td class="primary--text px-1 text-xs-center">
              <b>{{ $t('Facturas emitidas') }}</b>
            </td>
            <td
              class="px-0 text-xs-center"
              :class="{
                'secondary lighten-4':
                  currentDay >= 1 && currentDay <= 10
                    ? previousMonth == getMonthDate(month)
                    : currentMonth == getMonthDate(month),
              }"
              v-for="(month, m) in monthsN"
              :key="m"
            >
              <v-hover>
                <v-btn
                  slot-scope="{ hover }"
                  flat
                  icon
                  :color="`${hover ? 'primary' : 'grey lighten-1'}`"
                  @click="openUploadForm(month, 'issued-invoice')"
                >
                  <v-icon>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-hover>
            </td>
          </tr>
          <tr>
            <td class="primary--text px-1 text-xs-center">
              <b>{{ $t('Bancos') }}</b>
            </td>
            <td
              class="px-0 text-xs-center"
              :class="{
                'secondary lighten-4':
                  currentDay >= 1 && currentDay <= 10
                    ? previousMonth == getMonthDate(month)
                    : currentMonth == getMonthDate(month),
              }"
              v-for="(month, m) in monthsN"
              :key="m"
            >
              <v-hover>
                <v-btn
                  slot-scope="{ hover }"
                  flat
                  icon
                  :color="`${hover ? 'primary' : 'grey lighten-1'}`"
                  @click="openUploadForm(month, 'others')"
                >
                  <v-icon>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-hover>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="13">
              <div v-if="!formConfigReady" class="text-xs-center">
                <v-progress-circular color="primary" indeterminate></v-progress-circular>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </og-table>

    <v-dialog v-model="formUploadDialog" width="500">
      <aru-auto-form
        :key="formKey"
        v-if="formConfigReady"
        v-model="formData"
        :form-configuration="formConfig"
        :dismiss-button="true"
        dismiss-text="Close"
        @submit="submitFile"
        @dismiss="formUploadDialog = false"
      ></aru-auto-form>
    </v-dialog>

    <v-alert v-model="successAlert" dismissible color="primary" transition="scale-transition">
      {{ $t('El fichero se ha subido correctamente') }}
    </v-alert>

    <v-alert v-model="errorAlert" dismissible type="error" transition="scale-transition">
      {{ $t('Hubo un error al subir el fichero') }}
    </v-alert>

    <v-container class="px-0">
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <document-list
                v-if="searchConfigReady"
                :key="listKey"
                entity="document"
                @entitiesloaded="entitiesLoaded()"
                :level="1"
                search-input
                :search-config="searchConfig"
                default-icon="mdi-file-document-outline"
                three-line
                :from-user="true"
              ></document-list>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="uploading" fullscreen full-width>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-container>
</template>

<script>
import DocumentAPI from '@/services/api/document.js';
import OgTable from '@/components/commons/OgTable.vue';
// import FileIconStatus from '@/components/commons/FileIconStatus.vue';
// import OgUploadDocument from '@/components/commons/OgUploadDocument.vue';
import AruAutoForm from '@/components/commons/form/AruAutoForm.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import DocumentList from './DocumentList.vue';

export default {
  components: {
    OgTable,
    // FileIconStatus,
    // OgUploadDocument,
    AruAutoForm,
    DocumentList,
  },
  props: ['year'],
  data() {
    return {
      months: ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'],
      monthsN: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      currentMonth: new Date().toISOString().substr(0, 7),
      formUploadDialog: false,
      formKey: 0,
      formData: {},
      formConfig: {},
      formConfigReady: false,
      searchConfigReady: false,
      searchConfig: {},
      reload: false,
      listKey: 0,
      successAlert: false,
      errorAlert: false,
      uploading: false,
    };
  },
  computed: {
    previousMonth() {
      let date = new Date();
      date.setDate(0);
      return date.toISOString().substr(0, 7);
    },
    currentDay() {
      let date = new Date();
      return date.getDate();
    },
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    openUploadForm(month, type) {
      this.$set(this.formData, 'month', this.getMonthDate(month));
      this.$set(this.formData, 'type', type);
      this.successAlert = false;
      this.errorAlert = false;
      this.formUploadDialog = true;
    },
    getMonthDate(month) {
      return this.year + '-' + month;
    },
    getConfig() {
      this.searchConfigReady = false;
      this.formConfigReady = false;
      apiCtrl.get('/config/document').then(res => {
        console.log(res);
        if (res.data.data.hasOwnProperty('form')) {
          this.formConfig = res.data.data.form;
        }
        if (res.data.data.hasOwnProperty('contableSearch')) {
          this.searchConfig = res.data.data.contableSearch;
        }
        this.searchConfigReady = true;
        this.formConfigReady = true;
      });
    },
    submitFile(data) {
      this.uploading = true;
      let formData = new FormData();

      /*
                    Add the form data we need to submit
                */
      for (const field in data) {
        if (data.hasOwnProperty(field)) {
          const value = data[field];
          formData.append(field, value);
        }
      }
      DocumentAPI.postDocument(formData)
        .then(res => {
          this.resetForm();
          this.documentUploaded(res.data);
        })
        .catch(err => {
          this.uploadError(err);
        });
    },
    resetForm() {
      this.formKey++;
      this.uploading = false;
      this.formUploadDialog = false;
      this.formData = {};
    },
    uploadDocument(data) {
      console.log({ externalForm: data });
      let formData = new FormData();

      /*
                    Add the form data we need to submit
                */
      for (const field in data) {
        if (data.hasOwnProperty(field)) {
          const value = data[field];
          formData.append(field, value);
        }
      }
      DocumentAPI.postDocument(formData)
        .then(res => {
          console.log(res);
          this.resetForm();
        })
        .catch(error => {
          this.errorAlert = true;
          console.log(error);
        });
    },
    entitiesLoaded() {
      console.log('entitiesloaded');
      this.reload = false;
    },
    documentUploaded() {
      this.successAlert = true;

      console.log('documentUploaded');
      this.listKey++;
    },
    uploadError() {
      this.uploading = false;
      this.errorAlert = true;
    },
  },
  watch: {
    year: function() {
      this.getConfig();
    },
  },
};
</script>
